import {Component} from '@angular/core';
import {Loading, LoadingController, Platform} from 'ionic-angular';
import {AngularFire, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2';
import {Observable} from 'rxjs';
import {TranslatePipe, TranslateService} from "ng2-translate/ng2-translate";


@Component({
  templateUrl: 'build/pages/map/map.html',
  pipes: [TranslatePipe]
})
export class MapPage {
  map: any;
  trayectos: FirebaseListObservable<any[]>;
  waypts: any[] = [];
  
  constructor(public af: AngularFire, public loadCtrl: LoadingController, public platform: Platform, public translate: TranslateService) {
    this.platform = platform;
    this.trayectos = af.database.list('/trayectos');
    this.map = null;
    this.presentLoading();
    /*setTimeout(() => {
      this.loadMap();
    }, 100);
    */
  }
  
  presentLoading() {
    this.translate.get("loading").subscribe(value => {
      let loading = this.loadCtrl.create({
        content: value + "...",
        duration: 3000
      });
      loading.present();
    });
  }
  
  loadMap() {
    /*
    let options = {timeout: 10000, enableHighAccuracy: true};
    navigator.geolocation.getCurrentPosition(
        (position) => {
            let latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
            let mapOptions = {
                center: latLng,
                zoom: 15,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            }
            this.map = new google.maps.Map(document.getElementById("map"), mapOptions);
        },
        (error) => {
            console.log(error);
        }, options
    );
    */
    this.platform.ready().then(() => {
      let latLng = new google.maps.LatLng(36.841062, -4.244323);
      let mapOptions = {
        center: latLng,
        zoom: 15,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      this.map = new google.maps.Map(document.getElementById("map"), mapOptions);
      
      this.trayectos.do(snapshots => {
        snapshots.forEach((snapshot, index) => {
          this.addMarker(snapshot.lat, snapshot.lng, snapshot.salida);
          this.waypts.push({
              location: new google.maps.LatLng(snapshot.lat, snapshot.lng),
              stopover: true
          });
        });
        let directionsService = new google.maps.DirectionsService;
        let directionsDisplay = new google.maps.DirectionsRenderer;
        directionsDisplay.setMap(this.map);
        this.calculateAndDisplayRoute(directionsService, directionsDisplay, this.waypts);
      }).subscribe();
      /*
      let directionsService = new google.maps.DirectionsService;
      let directionsDisplay = new google.maps.DirectionsRenderer;
      directionsDisplay.setMap(this.map);
      this.calculateAndDisplayRoute(directionsService, directionsDisplay, this.waypts);
      */
    });
  }
  
  addMarker(lat, lng, info) {
    let latLng = new google.maps.LatLng(lat, lng);
    let marker = new google.maps.Marker({
      map: this.map,
      animation: google.maps.Animation.DROP,
      position: latLng
    });
    let content = "<ion-item><h4>" + info + "</h4><ion-thumbnail item-left><img src='img/algarrobo.jpg'></ion-thumbnail></ion-item>";          
    this.addInfoWindow(marker, content);
   }

  addInfoWindow(marker, content) {
    let infoWindow = new google.maps.InfoWindow({
      content: content
    });
    google.maps.event.addListener(marker, 'click', function() {
      infoWindow.open(this.map, marker);
    });
  }

  calculateAndDisplayRoute(directionsService: google.maps.DirectionsService, directionsDisplay: google.maps.DirectionsRenderer, waypts: any[]) {
    //console.log(waypts[4].stopover);
    //waypts.push('via:Centro Comercial Rincón de la Victoria');
    /*waypts.push({
              location: new google.maps.LatLng(36.819332, -3.991506),
              stopover: false
    });*/
    directionsService.route({
      origin: waypts.shift().location,
      destination: waypts.pop().location,
      waypoints: waypts,
      optimizeWaypoints: false,
      travelMode: google.maps.TravelMode.DRIVING
    }, (response, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        directionsDisplay.setDirections(response);
      }
    });
  }
  
}
